import { render, staticRenderFns } from "./FeedsForm.vue?vue&type=template&id=c3d1fbce&scoped=true&"
import script from "./FeedsForm.vue?vue&type=script&lang=js&"
export * from "./FeedsForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedsForm.vue?vue&type=style&index=0&id=c3d1fbce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d1fbce",
  null
  
)

export default component.exports